import { useContext, cloneElement, isValidElement } from "react";
import {
  CancelOutlined,
  DeleteForever,
  Edit,
  ViewHeadline,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import localize from "../../common/localize";
import { ModuleContext } from "./ModuleGuard";
import { isModuleActionRestricted } from "../../common/EntitiesManagement";

export default function ActionButtons({
  onClickForEditButton,
  onclickForDeleteButton,
  detailsButtonText,
  editButtonText,
  onClickForDetailButton,
  hideEditButton,
  hideDeleteButton,
  showCancelIcon,
  cancelButtonText,
  buttons, // [{name, icon, action}]
  style,
  disabled,
}) {
  const moduleForm = useContext(ModuleContext);
  const hideDelete =
    hideDeleteButton ||
    (moduleForm && isModuleActionRestricted(moduleForm, "DELETE"));
  // Force custom (extra) button icons to the app blue, overriding any color
  // the caller set on the icon (e.g. an inline color: "white").
  const forceBlueIcon = (icon) =>
    isValidElement(icon)
      ? cloneElement(icon, {
          style: {
            ...(icon.props?.style || {}),
            color: "var(--app-bg, #10366e)",
          },
        })
      : icon;
  return (
    <div className={style ?? "flex flex-col md:flex-row justify-center gap-2"}>
      {detailsButtonText &&
        (disabled ? (
          <button
            style={{
              background: "none",
              border: "none",
              color: "var(--app-bg, #10366e)",
            }}
            className={`btn app_button app_general_button_data btn-sm shrink flex-nowrap ${
              hideEditButton === true && hideDeleteButton === true
                ? "unique_action_button"
                : ""
            }`}
            disabled={disabled}
            onClick={onClickForDetailButton}
          >
            <ViewHeadline style={{ width: "16px", height: "16px" }} />
          </button>
        ) : (
          <Tooltip title={detailsButtonText}>
            <button
              style={{
                background: "none",
                border: "none",
                color: "var(--app-bg, #10366e)",
              }}
              className={`btn app_button app_general_button_data btn-sm shrink flex-nowrap ${
                hideEditButton === true && hideDeleteButton === true
                  ? "unique_action_button"
                  : ""
              }`}
              disabled={disabled}
              onClick={onClickForDetailButton}
            >
              <ViewHeadline style={{ width: "16px", height: "16px" }} />
            </button>
          </Tooltip>
        ))}

      {!hideEditButton &&
        (disabled ? (
          <button
            style={{
              background: "none",
              border: "none",
              color: "var(--app-bg, #10366e)",
            }}
            className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
            onClick={onClickForEditButton}
            disabled={disabled}
          >
            <Edit style={{ width: "16px", height: "16px" }} />
          </button>
        ) : (
          <Tooltip title={editButtonText ?? localize.edit}>
            <button
              style={{
                background: "none",
                border: "none",
                color: "var(--app-bg, #10366e)",
              }}
              className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
              onClick={onClickForEditButton}
              disabled={disabled}
            >
              <Edit style={{ width: "16px", height: "16px" }} />
            </button>
          </Tooltip>
        ))}

      {!hideDelete &&
        (disabled ? (
          <button
            style={{
              background: "none",
              border: "none",
              color: "var(--app-bg, #10366e)",
            }}
            className="btn btn-error app_general_button_data btn-sm shrink flex-nowrap"
            onClick={onclickForDeleteButton}
            disabled={disabled}
          >
            {showCancelIcon ? (
              <CancelOutlined style={{ width: "16px", height: "16px" }} />
            ) : (
              <DeleteForever style={{ width: "16px", height: "16px" }} />
            )}
          </button>
        ) : (
          <Tooltip
            title={
              showCancelIcon
                ? cancelButtonText
                  ? cancelButtonText
                  : localize.tooltip_cancel
                : localize.tooltip_delete
            }
          >
            <button
              style={{
                background: "none",
                border: "none",
                color: "var(--app-bg, #10366e)",
              }}
              className="btn btn-error app_general_button_data btn-sm shrink flex-nowrap"
              onClick={onclickForDeleteButton}
              disabled={disabled}
            >
              {showCancelIcon ? (
                <CancelOutlined style={{ width: "16px", height: "16px" }} />
              ) : (
                <DeleteForever style={{ width: "16px", height: "16px" }} />
              )}
            </button>
          </Tooltip>
        ))}

      {buttons &&
        buttons.length > 0 &&
        buttons.map((button) => {
          if (button.placeholder) {
            return (
              <button
                key={button.name}
                style={{
                  background: "none",
                  border: "none",
                  visibility: "hidden",
                }}
                className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
                disabled
                aria-hidden="true"
                tabIndex={-1}
              >
                {button.icon}
              </button>
            );
          }
          const buttonDisabled = disabled || button.disabled;
          return buttonDisabled ? (
            <button
              key={button.name}
              style={{
                background: "none",
                border: "none",
                color: "var(--app-bg, #10366e)",
              }}
              className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
              onClick={button.action}
              disabled={buttonDisabled}
            >
              {forceBlueIcon(button.icon)}
            </button>
          ) : (
            <Tooltip key={button.name} title={button.name}>
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--app-bg, #10366e)",
                }}
                className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
                onClick={button.action}
                disabled={buttonDisabled}
              >
                {forceBlueIcon(button.icon)}
              </button>
            </Tooltip>
          );
        })}
    </div>
  );
}
